import React, { useContext } from 'react';
import { Button, DatePicker, Form } from 'antd';
import { AppContext } from 'App.context';
import styles from './SelectDate.styles';
import useSelectDateHook from './SelectDate.hook';

export default function SelectDate({ onNext }) {
  const {
    appActions: { translate },
  } = useContext(AppContext);

  const { actions, state } = useSelectDateHook();

  return (
    <Form layout="vertical" form={state.form}>
      <div style={styles.dateSelectorContainer}>
        <div style={styles.dataSelectorChild}>
          <Form.Item label={translate('createBooking.steps.selectDate.startDate')} name="startDate">
            <DatePicker
              name="startDate"
              placeholder={translate('createBooking.steps.selectDate.startDatePlaceholder')}
              disabledDate={actions.disableStartDate}
              value={state.startDate}
              onChange={actions.startDateChange}
            />
          </Form.Item>
        </div>
        <div style={styles.dataSelectorChild}>
          <Form.Item label={translate('createBooking.steps.selectDate.endDate')} name="endDate">
            <DatePicker
              name="endDate"
              disabledDate={actions.disableEndDate}
              disabled={!Boolean(state.startDate)}
              value={state.endDate}
              onChange={actions.endDateChange}
              placeholder={translate('createBooking.steps.selectDate.endDatePlaceholder')}
            />
          </Form.Item>
        </div>
      </div>
      <Button
        type="primary"
        style={styles.button}
        size={'large'}
        disabled={!state.startDate || !state.endDate}
        onClick={() => {
          actions.saveBookingDates();
          onNext();
        }}
      >
        {translate('createBooking.steps.selectDate.button')}
      </Button>
    </Form>
  );
}
